<template>
  <div class="settlement-page">
    <PhoneForm v-if="$route.name == 'settlementSet'"> </PhoneForm>
    <router-view></router-view>
  </div>
</template>

<script>
import PhoneForm from './components/resultSet/phoneForm';
export default {
  name: 'settlementSet',
  components: {
    PhoneForm,
  },
};
</script>

<style></style>
